import { TargetIcon } from '@phosphor-icons/react';

import { goalNoteLabel, parseGoalNote } from '../../stores/goal';

/**
 * A `/goal` transition at the point in the thread where the agent loop recorded it: the goal
 * started, went into another iteration, paused or ended.
 *
 * The note's own text is written for the model, so the thread shows a one-line label read off its
 * JSON instead — neither side of the conversation wrote it.
 */
export function GoalNotice({ content }: { content: string }) {
  const note = parseGoalNote(content);
  if (!note) return null;
  return (
    <div className="flex items-center justify-center gap-1.5 text-xs text-fg-tertiary">
      <TargetIcon size={13} className="shrink-0" />
      <span className="min-w-0 truncate">{goalNoteLabel(note)}</span>
    </div>
  );
}
